import React from 'react';

const UpdateIndicator = ({ label }) => (
  <span
    className="update"
    {...(label
      ? { role: 'img', 'aria-label': label }
      : { 'aria-hidden': true })}
  />
);

export default UpdateIndicator;
